<template>
  <aside class="side-mini-panel with-vertical">
    <div class="sidebarmenu">

      <nav class="sidebar-nav d-block" id="menu-right-mini-1">
        <img v-show="theme == 'light'" src="@/assets/images/logo_black.png" class="dark-logo mb-5" alt="Logo-Dark"
          width="200" />
        <img v-show="theme == 'dark'" src="@/assets/images/logo.png" class="dark-logo mb-5" alt="Logo-Dark"
          width="200" />
        <ul class="sidebar-menu" id="sidebarnav">
          <li class="nav-small-cap">
            <span class="hide-menu">Dashboards</span>
          </li>
          <li class="sidebar-item" :class="{ 'selected': $route.path == '/home' }">
            <router-link class="sidebar-link" to="/home" aria-expanded="false">
              <iconify-icon icon="solar:widget-add-line-duotone"></iconify-icon>
              <span class="hide-menu">Inicio</span>
            </router-link>
          </li>
          <li class="sidebar-item" :class="{ 'selected': $route.path == '/clientes' }" v-if="individual.role_id > 3">
            <router-link to="/clientes" class="sidebar-link" aria-expanded="false">
              <i class="ti ti-user-circle"></i>
              <span class="hide-menu">Clientes</span>
            </router-link>
          </li>
          <!-- <li class="sidebar-item" :class="{ 'selected': $route.path == '/relatorios' }">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" aria-expanded="false"
              @click="toggleSubmenu('relatorios')">
              <i class="ti ti-clipboard-data"></i>
              <span class="hide-menu">Relatórios</span>
            </a>
            <ul :class="{
                collapse: true,
                'first-level': true,
                'in': activeSubmenu === 'relatorios'
              }">
              <li class="sidebar-item">
                <router-link to="/clientes" class="sidebar-link">
                  <span class="icon-small"></span>
                  Tipo 1
                </router-link>
              </li>
              <li class="sidebar-item">
                <router-link to="/clientes" class="sidebar-link">
                  <span class="icon-small"></span>
                  Tipo 2
                </router-link>
              </li>
              <li class="sidebar-item">
                <router-link to="/clientes" class="sidebar-link">
                  <span class="icon-small"></span>
                  Tipo 3
                </router-link>
              </li>
            </ul>
          </li> -->
          <li class="sidebar-item" :class="{ 'selected': $route.path == '/coletas' }">
            <a class="sidebar-link has-arrow" href="javascript:void(0)" aria-expanded="false"
              @click="toggleSubmenu('coletas')">
              <i class="ti ti-notes"></i>
              <span class="hide-menu">Coletas</span>
            </a>
            <ul :class="{
                collapse: true,
                'first-level': true,
                'in': activeSubmenu === 'coletas'
              }">
              <li class="sidebar-item">
                <router-link to="/coletas/aberta" class="sidebar-link">
                  <span class="icon-small"></span>
                  Chegada
                </router-link>
              </li>
              <li class="sidebar-item">
                <router-link to="/coletas/andamento" class="sidebar-link">
                  <span class="icon-small"></span>
                  Em andamento
                </router-link>
              </li>
              <li class="sidebar-item">
                <router-link to="/coletas/finalizada" class="sidebar-link">
                  <span class="icon-small"></span>
                  Finalizadas
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-small-cap" v-if="individual.role_id > 3">
            <span class="hide-menu">Administração</span>
          </li>
          <li class="sidebar-item" :class="{ 'selected': $route.path == '/colaboradores' }" v-if="individual.role_id > 3">
            <router-link to="/colaboradores" class="sidebar-link">
              <i class="ti ti-users"></i>
              <span class="hide-menu">Colaboradores</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: "AsideBar",
  data() {
    return {
      individual: null,
      activeSubmenu: null,
      theme: Cookies.get("theme") || "light"
    };
  },
  methods: {
    toggleSubmenu(submenu) {
      this.activeSubmenu = this.activeSubmenu === submenu ? null : submenu;
    },
  },
  mounted() {
    this.activeSubmenu = this.$route.path.split("/")[1];
  },
  created() {
    this.individual = JSON.parse(Cookies.get('individual'));
  }
};
</script>